@if (impersonationService.isImpersonating()) {
    <div class="w-full py-2 px-4 bg-warning text-warning-content flex items-center justify-center gap-3 text-sm font-medium z-50 shadow-md">
        <span class="font-bold">⚠ Admin-Ansicht:</span>
        <span>
            Sie sehen die Plattform als
            <strong>{{ impersonationService.impersonatedUser()?.name }}</strong>
            ({{ impersonationService.impersonatedUser()?.email }})
        </span>
        <button class="btn btn-xs btn-neutral ml-2" (click)="endSession()">
            Sitzung beenden
        </button>
    </div>
}
